import Doctor from './Doctor.page';

export default Doctor;
